import { ResumeDetails } from "../../../pages";
import adminRouteMap from "../../../routeControl/adminRouteMap";

export default function route() {
  return [
    {
      path: `${adminRouteMap.Resume_Details.path}/:id`,
      name: "Resume Details",
      key: `${adminRouteMap.Resume_Details.path}/:id`,
      commonRoute: false,
      private: true,
      belongsToSidebar: false,
      element: <ResumeDetails />,
    },
  ];
}
